import { useTranslation } from 'react-i18next'

import { Package } from '@phosphor-icons/react'

import { Card, CardTitle, Loading } from '@reveni-io/reveni-ui'

import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'
import { groupByValues } from '@/metrics/constants'

import ProductTypeTableHeader from '../ProductTypeTableHeader/ProductTypeTableHeader'
import Variant from '../Variant/Variant'
import * as Styles from './styles'

const VariantsCard = ({ data, onClickVariant, loading, salesOrdersDataActivated, ordering }) => {
  const { t } = useTranslation()

  const getOnClickHandler = variantPosition => {
    if (typeof onClickVariant === 'function') {
      return () => onClickVariant(variantPosition)
    }
  }

  return (
    <Card showBorder={false}>
      <CardTitle>
        <Styles.Title>
          <Package />
          {t('Variantes')}
        </Styles.Title>
      </CardTitle>
      <Loading show={loading} height="350px">
        <Styles.MainContainer>
          {data?.length > 0 ? (
            <div>
              <ProductTypeTableHeader
                type={groupByValues.variants}
                salesOrdersDataActivated={salesOrdersDataActivated}
                areElementsClickable={true}
                orderBy={ordering}
              />
              <Styles.TableContainer>
                {data?.map((variant, index) => (
                  <Variant
                    key={index}
                    variant={{ ...variant, index: index + 1 }}
                    onClick={getOnClickHandler(index)}
                    salesOrdersDataActivated={salesOrdersDataActivated}
                  />
                ))}
              </Styles.TableContainer>
            </div>
          ) : (
            <NoResultsFound />
          )}
        </Styles.MainContainer>
      </Loading>
    </Card>
  )
}

export default VariantsCard
